import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditApartments from "./editApartments";
import {
  LeadSource,
  getApartmentDropDown,
} from "services/redux/sales/corporate/leadDetails/action";
import { pocType } from "services/redux/sales/corporate/pocDetails/action";
import {
  leadCategories,
  rwaTenureFun,
} from "services/redux/sales/corporate/categoryDetails/action";
import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import { createApartmentLead } from "services/redux/sales/corporate/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";
import { excelUploadUrl } from "services/redux/fileUpload/action";
import { editApartmentLeadSubmit } from "services/redux/sales/editLead/action";
import { getDetails } from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  sourceData: state.LeadDetailsReducer.LeadSources,
  pocTypeData: state.pocTypesReducer.pocTypeData,
  rwaTenureData: state.categoryDetlReducer.rwaTenureData,
  leadCategory: state.categoryDetlReducer.leadCategory,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  appartmentDropDown: state.LeadDetailsReducer.appartmentDropDown,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
  viewDetails: state.preSalesListReducer.viewDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LeadSource,
      pocType,
      leadCategories,
      locationCity,
      locationZone,
      locationPinCode,
      locationArea,
      locationType,
      locationState,
      createApartmentLead,
      rwaTenureFun,
      getApartmentDropDown,
      getCurrentLocation,
      excelUploadUrl,
      editApartmentLeadSubmit,
      getDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditApartments);
